var productionMode = false;

const urlStart = "https://sahm-parts-dash.qtrust.id/";
const urlSSO = "https://sahmoil-sso.ahm.to/";

const VUE_APP_GOOGLE_MAPS_API_ID_DOMAIN_DETECTION = "48d5b2e803a56930f03e701b";
const VUE_APP_GOOGLE_MAPS_API_KEY_DOMAIN_DETECTION =
  "AIzaSyBAnH7ssyb8M79nk6o1mMXq_2DQDx1CwQI";

export default {
  productionMode,
  urlStart,
  urlSSO,
  VUE_APP_GOOGLE_MAPS_API_ID_DOMAIN_DETECTION,
  VUE_APP_GOOGLE_MAPS_API_KEY_DOMAIN_DETECTION,
};
